import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-transfer-scrutiny',
  templateUrl: './transfer-scrutiny.component.html',
  styleUrls: ['./transfer-scrutiny.component.scss']
})
export class TransferScrutinyComponent implements OnInit {
  TclcScrutiny: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  Table = false;
  APIService: any;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  collegeList: any;
  CertList: any;
  filteredCertList: any;
  TclcData: any;
  SessionNo: any;
  userPermission: any;
  Incoming: boolean;
  TclcIncoming: any;
  pageSize1 = 5;
  currentPage1 = 1;
  pageSize2 = 5;
  currentPage2 = 1;
  searchFilter1 = new FormControl('');
  searchFilter2 = new FormControl('');
  filteredTclcData: any[] = [];
  filteredTclcIncoming: any[] = [];

  // Updated restricted types to include RET
  restrictedTypes = ['ASC', 'RET', 'LANG', 'ATTFE', 'VOD'];

  constructor(
    private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.fetchCertType()
      this.ShowTable()
    }
    this.Table = false;
    this.sessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;
    let id = ''
    this.submitButton = true;
    this.editButton = false;
    this.TclcScrutiny = this.fb.group({
      CertType: new FormControl('All'),
    });
  }

  fetchSecretData() {
    this.spinner.show();
    this.umsService.getSecretData().subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.SessionNo = res.projectPharam['SnNo']
        this.fetchCertType()
        this.ShowTable()
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  fetchCertType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'TCLC';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.CertList = res.data;
        this.filteredCertList = this.CertList.slice();
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  ShowTable() {
    this.spinner.show();
    const payload = {};
    payload['SessionId'] = this.SessionNo;
    payload['CertType'] = this.TclcScrutiny?.get('CertType')?.value || 'All';
    this.spinner.show();
    this.umsService.GetTclcData(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.show();
        if (this.userPermission[0].CgUi == 'C') {
          this.TclcData = res.data.filter(record => record.StuCollege == this.userPermission[0].CgId);
          this.TclcIncoming = res.data.filter(record => record.DestClg == this.userPermission[0].CgId && record.CertType != 'ADMC' && record.FeeStatus == 'Y');
          this.filteredTclcData = [...this.TclcData];
          this.filteredTclcIncoming = [...this.TclcIncoming];

          if (this.TclcData.length != 0 && this.TclcIncoming.length != 0) {
            this.Table = true;
            this.Incoming = true;
          }
          else if (this.TclcData.length != 0 && this.TclcIncoming.length == 0) {
            this.Table = true;
            this.Incoming = false;
          }
          else if (this.TclcData.length == 0 && this.TclcIncoming.length != 0) {
            this.Table = false;
            this.Incoming = true;
          }
          else if (this.TclcData.length == 0 && this.TclcIncoming.length == 0) {
            this.Table = false;
            this.Incoming = false;
          }

          this.spinner.hide()
        }
        else {
          this.TclcData = res.data
          this.filteredTclcData = [...this.TclcData];
          this.Incoming = false;
          if (this.TclcData.length == 0) {
            this.Table = false;
          }
          else {
            this.Table = true;
          }
          this.spinner.hide()
        }
        this.searchFilter1.valueChanges.subscribe((searchTerm) => {
          this.applyFilter(1, searchTerm);
        });

        this.searchFilter2.valueChanges.subscribe((searchTerm) => {
          this.applyFilter(2, searchTerm);
        });
      }
      else {
        this.Table = false;
        this.Incoming = false
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.Table = false;
      this.Incoming = false
      this.spinner.hide()
    });
  }

  getStatus(tclc: any): string {
    let status = '';

    switch (tclc['CertStatus']) {
      case "APR":
        if (tclc['CertType'] == "ADMC") {
          status = tclc['RgStatus'] == "L" ? 'Application Approved' : 'Application InProcess';
        } else {
          status = 'Certificate Generated';
        }
        break;

      case "APPAP":
        if (tclc['CertType'] == "ADMC") {
          status = tclc['RgStatus'] == "L" ? 'Application Approved' : 'Application InProcess';
        } else {
          status = 'Application Approved';
        }
        break;

      case "REJ":
        status = 'Rejected';
        break;

      case "REC":
        status = 'Rectify';
        break;

      case "Submitted":
        status = 'Submitted';
        break;

      case "ReSubmitted":
        status = 'Re-Submitted';
        break;
      case "UFD":
        status = 'TS Certificate Generated';
        break;
      default:
        status = tclc['CertStatus'];
        break;
    }

    return status;
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  // ============ MODIFIED: details method with debug and router state ============
  details(data: any) {
    console.log('========== TransferScrutiny - Passing Data ==========');
    console.log('Full data object:', data);
    console.log('OrgId value:', data.OrgId);
    console.log('OrgId type:', typeof data.OrgId);
    console.log('FeeStatus:', data.FeeStatus);
    console.log('CertType:', data.CertType);
    console.log('TclcId:', data.TclcId);
    console.log('=====================================================');

    this.umsService.setTclcData(data);

    sessionStorage.setItem('tclcData', JSON.stringify(data));

    this.router.navigate(['TclcApproval'], {
      state: {
        tclcData: data
      }
    });
  }

  viewPaymentReceipt(data: any) {
    console.log('View Payment Receipt clicked for:', data);
  }

  hasOrgId(data: any): boolean {
    return data && data.OrgId != null && data.OrgId !== 0 && data.OrgId !== '' && data.OrgId !== 'null';
  }

  applyFilter(tableNumber: number, searchTerm: string) {
    if (tableNumber === 1) {
      this.filteredTclcData = this.TclcData.filter(item =>
        JSON.stringify(item).toLowerCase().includes(searchTerm.toLowerCase())
      );
    } else if (tableNumber === 2) {
      this.filteredTclcIncoming = this.TclcIncoming.filter(item =>
        JSON.stringify(item).toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
  }

  getPaginatedData(tableNumber: number) {
    const start = (tableNumber === 1 ? (this.currentPage1 - 1) : (this.currentPage2 - 1)) * (tableNumber === 1 ? this.pageSize1 : this.pageSize2);
    const end = start + (tableNumber === 1 ? this.pageSize1 : this.pageSize2);
    const data = tableNumber === 1 ? this.filteredTclcData.slice(start, end) : this.filteredTclcIncoming.slice(start, end);
    return data;
  }

  onPageChange(event: any, tableNumber: number) {
    if (tableNumber === 1) {
      this.currentPage1 = event.pageIndex + 1;
      this.pageSize1 = event.pageSize;
    } else if (tableNumber === 2) {
      this.currentPage2 = event.pageIndex + 1;
      this.pageSize2 = event.pageSize;
    }
  }

  showEye(tclc: any): boolean {
    const certType = tclc.CertType?.toUpperCase().trim();
    return !this.restrictedTypes.includes(certType)
      || (this.restrictedTypes.includes(certType));
  }
  isVodSelected(): boolean {
    return this.TclcScrutiny?.get('CertType')?.value === 'VOD';
  }
downloadVodReport(): void {
  const vodData = (this.filteredTclcData && this.filteredTclcData.length
    ? this.filteredTclcData
    : this.TclcData || []).filter((row: any) => row.CertType === 'VOD');

  if (!vodData || vodData.length === 0) {
    alert('No VOD records available to download.');
    return;
  }

  const reportData = vodData.map((item: any) => ({
    'RgNo': item.RgNo != null ? item.RgNo : item.StuPRN,
    'Document Status': item.Uploadstatus,
    'Student Name': item.StuName !== null && item.StuName !== undefined && item.StuName !== ''
      ? item.StuName
      : `${item.StuFirstNameEng ?? ''} ${item.StuMidNameEng ?? ''} ${item.StuLastNameEng ?? ''}`.trim(),
    'Course Name': item.CoName,
    'College': item.CgName,
    'Request Type': this.getRequestTypeLabel(item.CertType),
    'Action': this.getStatus(item),
    'Fee Status': item.FeeStatus == 'Y' ? 'Paid' : 'Not Paid',
    'Status By': item.StatusBy,
    'Date': item.CreatedAt ?? ''
  }));

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(reportData);

  const colWidths = Object.keys(reportData[0] || {}).map((key: string) => {
    const maxLen = Math.max(
      key.length,
      ...reportData.map((row: any) => String(row[key] ?? '').length)
    );
    return { wch: maxLen + 2 };
  });
  worksheet['!cols'] = colWidths;

  const workbook: XLSX.WorkBook = {
    Sheets: { 'Verification_Report': worksheet },
    SheetNames: ['Verification_Report']
  };
  const fileName = `Verification_Report_${new Date().toISOString().slice(0, 10)}.xlsx`;
  XLSX.writeFile(workbook, fileName);
}

  private getRequestTypeLabel(certType: string): string {
    switch (certType) {
      case 'TC': return 'Transfer Certificate';
      case 'LC': return 'Leaving Certificate';
      case 'MC': return 'Migration Certificate';
      case 'ADMC': return 'Admission Cancellation';
      case 'TS': return 'Transcript Certificate';
      case 'ASC': return 'ASC Certificate';
      case 'RET': return 'Retotalling';
      case 'LANG': return 'Language Certificate';
      case 'ATTFE': return 'Attestation Certificate';
      case 'VOD': return 'Verification of University Document';
      default: return '';
    }
  }
}